module.exports = __webpack_public_path__ + "d4c0b303/img/scraper-icon.df6ccde5.svg";